import { render } from "./AppLoading.vue?vue&type=template&id=f023242a&scoped=true"
import script from "./AppLoading.vue?vue&type=script&lang=js"
export * from "./AppLoading.vue?vue&type=script&lang=js"

import "./AppLoading.vue?vue&type=style&index=0&id=f023242a&lang=css&scoped=true"

import exportComponent from "/home/harry/Desktop/Vue JS/Matrix Digital/Alearif zain portal/alearif-zain/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f023242a"]])

export default __exports__